/**
 * @generated SignedSource<<7431176864a95851a1c2361f1733f747>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SearchBar_viewer$data = {
  readonly searchSuggestions?: {
    readonly suggestions: ReadonlyArray<{
      readonly type: string | null;
      readonly terms: ReadonlyArray<{
        readonly term: string | null;
        readonly urlLabel: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
  readonly user?: {
    readonly " $fragmentSpreads": FragmentRefs<"getRecentHistory_user">;
  } | null;
  readonly " $fragmentType": "SearchBar_viewer";
};
export type SearchBar_viewer$key = {
  readonly " $data"?: SearchBar_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SearchBar_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "hasQuery"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "query"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SearchBar_viewer",
  "selections": [
    {
      "condition": "hasQuery",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "includeTypes",
              "value": [
                "POPULAR",
                "CATEGORY",
                "SELLER",
                "CREATOR"
              ]
            },
            {
              "kind": "Variable",
              "name": "query",
              "variableName": "query"
            }
          ],
          "concreteType": "SearchSuggestion",
          "kind": "LinkedField",
          "name": "searchSuggestions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchSuggestionList",
              "kind": "LinkedField",
              "name": "suggestions",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SearchSuggestionTerm",
                  "kind": "LinkedField",
                  "name": "terms",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "term",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "urlLabel",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "kind": "Defer",
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "getRecentHistory_user"
                }
              ]
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2c3938a90e7461be8ddad9b687098af5";

export default node;
